import mainService from "./mainService";
const path = "/messages";

export function getMessages(roomId , lastMessage ) {
    return mainService
        .post(path + "/getMessages", { roomId : roomId , last : lastMessage  })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function getRooms() {
    return mainService
        .post(path + "/getRooms")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function records() {
    return mainService
        .post(path + "/records")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export function create(userId , jobId )  {
    return mainService
        .post(path + "/create", {userId : userId  , jobId : jobId })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function send(message , roomId , files )  {
    return mainService
        .post(path + "/send", {message : message  , id : roomId , files : files })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/message.jsx